import React from 'react';
import { Spin } from 'antd';

/**
 * SbSpin - Standardized loading spinner wrapper for SkillsBridge
 * 
 * Wraps Ant Design's Spin component with consistent styling.
 * 
 * Usage:
 *   import { SbSpin } from 'uiCore';
 *   
 *   <SbSpin />
 *   <SbSpin size="large" />
 *   <SbSpin spinning={loading}>
 *     <div>Content to show when not loading</div>
 *   </SbSpin>
 */

const SbSpin = ({ children, ...rest }) => {
  if (children) {
    return (
      <Spin {...rest}>
        {children}
      </Spin>
    );
  }

  return <Spin {...rest} />;
};

export default SbSpin;
